import * as React from 'react';
import { IconClose12 } from '@cian/ui-kit';

import { IBackToPageProps } from './types';

import * as styles from './styles.css';

export function BackToPageMobile(props: IBackToPageProps) {
  return (
    <a href={props.href} className={styles['mobile']} onClick={props.onClick}>
      <IconClose12 />
    </a>
  );
}
